import React, { FC, useState, useEffect, useContext } from 'react'
import history from '../../../history'

import { notify } from 'react-notify-toast'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
import { deleteFeed } from '../../../Api/backendApi'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../GenericComponents/GenericCloseButton'
import GenericCard from '../../../GenericComponents/GenericMainCard'

interface RemoveProgressModalInterface {
  closeModal: Function
  goToSub: Function
  modalMode: string
}

const RemoveProgressModal: FC<RemoveProgressModalInterface> = ({
  closeModal,
  goToSub,
  modalMode,
}) => {
  return (
    <GenericCard
      flexDir={'column'}
      className="standard"
      width={'100%'}
      margin={' auto'}
    >
      <GenericCloseButton onClick={closeModal} />

      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          {modalMode}
        </GenericTextSpan>
      </GenericRow>

      <GenericRow>
        <GenericTextSpan
          fSize={'1.4rem'}
          margin={'3% 0 0 0'}
          fWeight={'normal'}
          width={isMobile ? '90%' : '60%'}
        >
          {modalMode == 'Panel diet'
            ? 'Panel diet nie jest dostępny. Wykup dostęp aby wykorzystać wszystkie funkcje aplikacji. '
            : 'Wyzwania panel diet'
            ? 'Panel diet dostępny po wykupieniu dostępu.'
            : `Treningi wspólne nie są dostępne w trybie demonstracyjnym. Wykup subskrypcję aby wykorzystać wszystkie funkcje aplikacji. `}
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericButton
          width={isMobile ? '90%' : '40%'}
          className="standard"
          margin={'4% auto'}
          justify={'center'}
          onClick={() => goToSub()}
        >
          {modalMode === 'Wyzwania panel diet'
            ? 'Wykup panel diet'
            : 'Kup subskrypcję'}
        </GenericButton>
      </GenericRow>
    </GenericCard>
  )
}

export default RemoveProgressModal
